<template>
  <!-- <div>{{ data }}</div> -->
  <div class="cardRow" @click.stop="clickCard(item)" v-for="(item, index) in productsData" :key="index">
    <div class="fvlrw head">
      <div class="fhlud left">
        <span class="creatTime">创建时间：{{ item.creatTime }}</span>
        <span class="creatTime">订单编号：{{ item.orderNo }}</span>
      </div>
      <p class="statusCol">
        <span class="remind" v-if="item.statusData.showCountDown && item.residueTime > 0">
          请您在
          <van-count-down :time="item.residueTime" format="mm:ss" @finish="refresh(index)" />分钟内完成付款
        </span>
        <span v-else>
          <img v-if="item.statusData.showDeleteIcon" src="../../assets/images/delete-o.png" class="iconImg" @click.stop="clickDelete(item)" />
          <van-tag
            v-if="item.orderTypeFlag === EWOrderTypeFlag && ['已退款', '已退货', '退款中'].includes(item.statusData.zh)"
            size="medium"
            color="#3088c5"
            plain
            >{{ item.statusData.zh }}</van-tag
          >
          <span v-else>{{ item.statusData.zh }}</span>
        </span>
      </p>
    </div>
    <BaseCard :data="getBaseData(item)" @click.stop="clickCard(item)">
      <template #Ifn>
        <p class="baseSlot">
          <span class="viewDealer underline themeColor" @click.stop="viewUseDealer(item)">查看可用经销商</span>
          <span class="priceNum"> ¥{{ item.productInfo?.productPrice }} </span> <span class="priceWord themeColor">零售价</span>
        </p>
      </template>
    </BaseCard>

    <div class="fvr statusBtn">
      <span
        >订单金额：<span class="payAmountNum themeRed">￥{{ item?.payAmount }}</span></span
      >
      <BottomBtn v-if="item.btnData && item.btnData.length" :data="item.btnData" @click="clickBtn" size="small" />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref, nextTick } from 'vue'
import BottomBtn from '@/components/order/BottomBtn'
import BaseCard from '@/components/directSales/BaseCard'
import { EWOrderTypeFlag } from '../../util/order/staticConfig'

export default {
  props: {
    data: {
      type: [Object, Array],
      default: () => []
    }
  },
  components: {
    BottomBtn,
    BaseCard
  },
  emits: ['clickCard', 'clickImg', 'clickBtn', 'viewUseDealer', 'clickDelete', 'refresh'],
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value
    })
    const isArrayFn = value => {
      if (typeof Array.isArray === 'function') {
        return Array.isArray(value)
      } else {
        return Object.prototype.toString.call(value) === '[object Array]'
      }
    }
    const productsData = computed(() => (isArrayFn(data.value) ? data.value : [data.value]))
    const getBaseData = data => {
      return {
        thumbnail: data?.productInfo?.thumbnail,
        productName: data.productsName,
        productNames: data.productsNames,
        dealerName: data.dealer.name,
        carText: `${data?.carInfo?.plate || ''} | ${data?.carInfo?.model || ''}`
      }
    }

    const viewUseDealer = data => {
      let pram = { orderId: state.data.id, orderTypeFlag: data?.orderTypeFlag, sign: 'contractOrder', useclick: false }
      emit('viewUseDealer', pram)
    }

    const clickCard = v => {
      // console.log('clickCard-->', v)
      emit('clickCard', { ...v, orderId: v.id })
    }
    const clickBtn = v => {
      emit('clickBtn', v)
    }
    const clickDelete = v => {
      emit('clickDelete', v)
    }
    const refresh = () => {
      emit('refresh')
    }
    const clickImg = v => {
      // console.log("clickImg-->", v);
      emit('clickImg', v)
    }
    return {
      ...toRefs(state),
      clickCard,
      clickImg,
      clickBtn,
      productsData,
      EWOrderTypeFlag,
      viewUseDealer,
      getBaseData,
      clickDelete,
      refresh
      // useDealerRef
    }
  }
}
</script>
<style lang="scss" scoped>
.cardRow {
  width: 100%;
}
.head {
  padding: 10px;
  margin: 1px 0 10px;
  border-bottom: 1px solid #f0f0f0;
  .left span {
    line-height: 20px;
    font-size: 13px;
  }
}
.cardRow + .cardRow {
  margin-top: 5px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.statusBtn {
  width: 100%;
  span {
    font-size: 14px;
    font-weight: 600;
  }
  .btnCompnentBox {
    margin-left: 10px;
  }
}
.statusCol {
  text-align: right;
  img {
    width: 14px;
    height: 16px;
    vertical-align: middle;
  }
  span {
    margin-left: 5px;
    vertical-align: middle;
  }
}
.baseSlot {
  margin-bottom: 20px;
}
.viewDealer {
  padding-right: 10px;
}
.priceNum {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
}
.priceWord {
  margin-left: 18px;
  padding: 5px 8px;
  font-size: 12px;
  background: #e1edf6;
  border-radius: 5px;
}
</style>
